import * as Effect from "effect/Effect";
import * as Random from "effect/Random";
export const DEFAULT_RECONNECT_BACKOFF = {
    initialDelayMs: 1_000,
    backoffFactor: 2,
    maxDelayMs: 64_000,
    maxRetries: null,
};
export function getReconnectDelayMs(retryIndex, config = DEFAULT_RECONNECT_BACKOFF) {
    if (!Number.isInteger(retryIndex) || retryIndex < 0) {
        return null;
    }
    if (config.maxRetries !== null && retryIndex >= config.maxRetries) {
        return null;
    }
    const ceiling = Math.min(config.initialDelayMs * config.backoffFactor ** retryIndex, config.maxDelayMs);
    return Math.round(ceiling * (0.5 + Effect.runSync(Random.next) * 0.5));
}
